<template>
  <vue-tel-input
    v-model="number"
    v-bind="bindProps"
    @input="handleInput"
  ></vue-tel-input>
</template>

<script>
  /* ============
   * Phone Number Input - vue-tel
   * ============
   *
   * Do some desc
   */

  export default {
    name: 'PhoneNumberInput',
    props: {
      phoneNumber: {
        type: String
      },
      value: {
        type: Object,
        default() {
          return {
            number: '',
            valid: false
          }
        }
      }
    },

    data() {
      return {
        number: this.value ? this.value.number : '',
        bindProps: {
          mode: "international",
          preferredCountries: ["NL", "BE", "DE", "FR", "HR"],
          inputOptions: {
            placeholder: this.$i18n.t("Phone number"),
          },
          invalidMsg: "aokoko"
        }
      }
    },

    methods: {
      handleInput(value, {valid, number}) {
        const input= {valid, number: valid ? number : value};
        this.$emit('input', input)
      },
    },

    watch: {
      phoneNumber(newVal, oldVal) {
        this.number = newVal;
      }
    },

  };
</script>


